"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montechiaro-d-acqui": {
    "b9fb31de": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "barini": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86ab07da": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "carozzi": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb1503ba": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "cerceto": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48ce3db2": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "dogliotti": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6c380c9": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "ferretti": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "122f4b36": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "gaggioni": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8890a91": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "madonna": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac89820d": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "marenchi": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c869cf42": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ca20395": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "pamparato": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e746c15e": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "piampodazza": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01f3d0ed": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "satragni": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e93e3ae": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "skipSearch": false
    }],
    "vaccamorta": [{
      "hkey": "8a7d7aaf",
      "slug": "montechiaro-d-acqui",
      "name": "Montechiaro d'Acqui",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;